import api from "../controllers/api";
import Cookies from "js-cookie";
const authToken = Cookies.get("authToken");
export const addressStateCityPincode = async (type, value) => {
  let url = `/address/get?country=india`;
  if (type === "country") {
    // returns list of states
    url = `/address/get?country=india`;
  } else if (type === "state") {
    // returns list of city present in state
    url = `/address/get?country=india&state=${value}`;
  } else if (type === "city") {
    // returns list of pincode in this city
    url = `/address/get?country=india&city=${value}`;
  } else if (type === "pincode") {
    // return in response state and city
    url = `/address/get?country=india&pincode=${value}`;
  } else {
    url = `/address/get?country=india`;
  }
  try {
    // const url = `/address/get?country=india`;
    const result = await api.get(url);
    return result;
  } catch (error) {
    throw error;
  }
};

export const verifyUberIdAPI = async (uberId, phoneNumber, driverId) => {
  // required fields
  // driver_uber_id  , firstName , lastName , phoneNumber:{ countryCode,number}
  try {
    const url = `/driver/checkUberId`;
    const data = {};
    data["driver_uber_id"] = uberId;
    // data[ 'firstName'] =firstName
    data["phoneNumber"] = { countryCode: "+91", number: phoneNumber };
    data["driver_id"] = driverId;
    // {lastName?data['lastName'] = lastName:''}
    // if(lastName !== '' && lastName !== undefined && lastName !== null){
    //     data['lastName'] = lastName

    // }else{
    //     data['lastName'] = '-'
    // }
    const result = await api.post(url, data);
    return result;
  } catch (error) {
    throw error;
  }
};

export const postData = async (url, data, formdata) => {
  const authToken = Cookies.get("authToken");
  try {
    let header = {};
    if (formdata) {
      header = {
        Authorization: `carrum ${authToken}`,
        // 'Content-Type': 'multipart/form-data',
      };
    } else {
      header = {
        Authorization: `carrum ${authToken}`,
        "Content-Type": "application/json",
      };
    }
    const result = await fetch(`${process.env.REACT_APP_SERVER_URL}${url}`, {
      method: "POST",
      headers: header,
      body: data,
    });
    const newResult = await result.json();
    return newResult;
  } catch (error) {
    throw error;
  }
};

export const getData = async (url) => {
  const authToken = Cookies.get("authToken");
  try {
    const result = await fetch(`${process.env.REACT_APP_SERVER_URL}${url}`, {
      method: "GET",
      headers: {
        Authorization: `carrum ${authToken}`,
        "Content-Type": "application/json",
      },
    });
    return result;
  } catch (error) {
    throw error;
  }
};
